import { Component, OnInit } from '@angular/core';
import { DataTable, DataTableResource, DataTableTranslations } from 'angular7-data-table';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { NgbModalRef, NgbModalOptions, NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import Swal from "sweetalert2";
import { ConfirmationComponent } from 'src/app/common/components/confirmation/confirmation.component';
import { PlanService } from '../../plan-management/plan.service';
import { OrganizationService } from '../organization.service';
import { Router } from '@angular/router';
import { CommonService } from 'src/app/common/common.service';
import {MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS} from '@angular/material-moment-adapter';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';
import * as _moment from 'moment';
// tslint:disable-next-line:no-duplicate-imports
import {defaultFormat as _rollupMoment, Moment} from 'moment';
export const MY_FORMATS = {
  parse: {
    dateInput: 'MM/YYYY',
  },
  display: {
    dateInput: 'MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@Component({
  selector: 'app-view',
  templateUrl: './view.component.html',
  styleUrls: ['./view.component.css'],
  providers: [
    // `MomentDateAdapter` can be automatically provided by importing `MomentDateModule` in your
    // application's root module. We provide it at the component level here, due to limitations of
    // our example generation script.
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
    },

    {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS},
  ],
})
export class ViewOrganizationComponent implements OnInit {
date:any;
  private modalRef: NgbModalRef;

  modelOptions: NgbModalOptions = {
    backdrop: "static",
    keyboard: false,
    centered: true,
  };
  modelOptions1: NgbModalOptions = {
    backdrop: "static",
    keyboard: false,
    centered: true,
    size:'lg'
  };
  statusList: Array<object> = [
    { id: "active", name: "Active" },
    { id: "blocked", name: "Blocked" }
  ];
  closeResult: string;
  statusFormSubmitted: boolean = false;
  planDetails: any;
  statusForm: FormGroup;
  featureList = [];
  finalFeatureList = [];
  emailPattern = /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$/;
  organizationList = [];
  temp: any;
  feature: string;
  plancount: number;
  plan_id: any;
  planForm:FormGroup;
  formSubmitted:boolean = false;
  headerTitle:string ='Add User'
  userData:any;
  monthNames = ["Jan", "Feb", "March", "April", "May", "June",
  "July", "August", "Sept", "Oct", "Nov", "Dec"
];
uniqueUser=0
monthDisplay=""
  constructor(
    private formBuilder: FormBuilder,
    private modalService: NgbModal,
    private organizationService: OrganizationService, 
    private spinner: NgxSpinnerService,
    private router: Router, 
    private common:CommonService) { }

  ngOnInit() {
    this.date = new Date();
    this.monthDisplay = this.monthNames[this.date.getMonth()]+" "+this.date.getFullYear();
    
    this.userData = this.common.getUser();
    this.initialiseForms();
    this.spinner.show();
    this.getOrgs();
    // this.startLoadingSpinner();
  }

  initialiseForms() {
    this.planForm = this.formBuilder.group({
      email:["", [Validators.required, Validators.pattern(this.emailPattern)]],
      password: ["", [Validators.required,Validators.minLength(6)]],
      fullName: ["", [Validators.required]],
    });
  }
  initialiseForms1() {
    this.planForm = this.formBuilder.group({
      email: ["", [Validators.required]],
      fullName: ["", [Validators.required]],
    });
  }
  startLoadingSpinner() {

    setTimeout(function () {
      this.spinner.hide();
    }.bind(this), 3000);
  }

  labels = <DataTableTranslations>{
    loadingText: 'Your {title} table is reloading - and this is my custom message.',
    paginationText: 'Your table displays {from} to {to} of {total} rows.'
  };
  prepareUpdateStatusForm() {
    this.statusForm = this.formBuilder.group({
      newStatus: ["", [Validators.required]]
    });
  }
  getOrgs() {
    let query ="";
    if(this.date){
      var date = new Date(), year = this.date.getFullYear(), month = this.date.getMonth();
      var firstDay = new Date(year, month, 1);
      var lastDay = new Date(year, month + 1, 0);
      let startDate= new Date(firstDay).setHours(0, 0, 0, 0)/1000;
      let endDate = new Date(lastDay).setHours(23, 59, 59, 0)/1000
      query = query+'&startTime='+startDate+"&endTime="+endDate
     }
    this.organizationService.getOrganizationsApi(query).subscribe(res => {
      this.spinner.show();
      if ((res["status"] == "Success")) {
        this.organizationList = res.data.organizationList;
        this.plancount = this.organizationList.length
        this.spinner.hide();
      } else {
        this.spinner.hide();
        Swal.fire({
          type: "error",
          title: "Error",
          text: res.msg
        });
      }
    }, err => {
      this.spinner.hide();
    });

  }


  updateForm(data) {

    this.planForm.patchValue({
      fullName: data.fullName,
      email: data.email
    });

    // this.AsrForm.controls['week'].disable();
  }
  updateUserStatusModal(row, content, btn) {
    btn && btn.parentElement && btn.parentElement.parentElement && btn.parentElement.parentElement.blur();

    this.planDetails = row;
    this.statusFormSubmitted = false;
    this.prepareUpdateStatusForm();
    this.modalRef = this.modalService.open(content, this.modelOptions);
    this.modalRef.result.then(
      result => {
        this.closeResult = `Closed with: ${result}`;
      },
      reason => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
  }
  updateUserStatusModal2(row, content, btn) {
    btn && btn.parentElement && btn.parentElement.parentElement && btn.parentElement.parentElement.blur();
    if(row == 'row') {
      this.initialiseForms();
      this.headerTitle ='Add User';
    }else {
      this.headerTitle ='Edit User'
      this.initialiseForms1();
      this.updateForm(row);
    }
    this.planDetails = row;
    this.statusFormSubmitted = false;
    this.prepareUpdateStatusForm();
    this.modalRef = this.modalService.open(content, this.modelOptions);
    this.modalRef.result.then(
      result => {
        this.closeResult = `Closed with: ${result}`;
      },
      reason => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
  }
  updateUserStatusModal1(row, content, btn) {

    this.plan_id = row.reporterId;
    btn && btn.parentElement && btn.parentElement.parentElement && btn.parentElement.parentElement.blur();

    this.planDetails = row;
    
    this.modalRef = this.modalService.open(content, this.modelOptions);
    this.modalRef.result.then(
      result => {
        this.closeResult = `Closed with: ${result}`;
      },
      reason => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
  }
  providerList =[];
  openModal(row, content, btn) {
    this.providerList =[]
if(row.providerCount == 0){
  return
}
this.planDetails = row;
this.spinner.show();
  let query ='organizationId='+this.planDetails['organizationId']
this.organizationService.getProviderApi(query).subscribe(res => {
  this.spinner.show();
  if ((res["status"] == "Success")) {
    this.providerList = res.data.providerList;
    btn && btn.parentElement && btn.parentElement.parentElement && btn.parentElement.parentElement.blur();

    this.planDetails = row;
    this.modalRef = this.modalService.open(content, this.modelOptions);
    this.modalRef.result.then(
      result => {
        this.closeResult = `Closed with: ${result}`;
      },
      reason => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
    this.spinner.hide();
  } else {
    this.spinner.hide();
  }
}, err => {
  this.spinner.hide();
});
    
   
  }
  openModal1(row, content, btn) {
    this.providerList =[]
    if(row.visitorsCount == 0){
      return
    }
    this.planDetails = row;
    this.spinner.show();
      let query ='organizationId='+this.planDetails['organizationId'];
      if(this.date){
        var date = new Date(), year = this.date.getFullYear(), month = this.date.getMonth();
        var firstDay = new Date(year, month, 1);
        var lastDay = new Date(year, month + 1, 0);
        let startDate= new Date(firstDay).setHours(0, 0, 0, 0)/1000;
        let endDate = new Date(lastDay).setHours(23, 59, 59, 0)/1000
        query = query+'&startTime='+startDate+"&endTime="+endDate
       }
    this.organizationService.getProfileInfo(query).subscribe(res => {
      this.spinner.hide();
      if ((res["message"] == "Success")) {
        this.providerList = res.data.auditLogs;
        this.uniqueUser = res.data.uniqueUsersCount;
        btn && btn.parentElement && btn.parentElement.parentElement && btn.parentElement.parentElement.blur();
    
        this.planDetails = row;
        this.modalRef = this.modalService.open(content, this.modelOptions1);
        this.modalRef.result.then(
          result => {
            this.closeResult = `Closed with: ${result}`;
          },
          reason => {
            this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
          }
        );
        this.spinner.hide();
      } else {
        this.spinner.hide();
        Swal.fire({
          type: "error",
          title: "Error",
          text: res.msg
        });
      }
    }, err => {
      this.spinner.hide();
    });
        
       
      }
  navigateDetail(row) {
    this.modalRef.close();
    this.router.navigate(['main/provider/view/'], { queryParams: { id: this.planDetails['organizationId'] }, preserveQueryParams: false });

  }
  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return "by pressing ESC";
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return "by clicking on a backdrop";
    } else {
      return `with: ${reason}`;
    }
  }

  confirmDeleteRecord(record: any) {

    let modalRef = this.modalService.open(ConfirmationComponent, this.modelOptions);
    modalRef.componentInstance.content = "Are you sure you want to delete this record?";
    modalRef.componentInstance.leftButton = "No";
    modalRef.componentInstance.rightButton = "Yes";
    modalRef.result.then(
      (data: any) => {
        if (data == "yes") {
          this.deleteRecord(record);
        }
      },
      (reason: any) => { }
    );
  }

  deleteStatusModal(row, content, btn) {
    btn && btn.parentElement && btn.parentElement.parentElement && btn.parentElement.parentElement.blur();


    this.modalRef = this.modalService.open(content, this.modelOptions);
    this.modalRef.result.then(
      result => {
        this.closeResult = `Closed with: ${result}`;
      },
      reason => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
  }


  deleteRecord(record: any) {

    this.spinner.show();
let query = this.planDetails.organizationId;
    this.organizationService.deleteOrganizationApi(query).subscribe(res => {
      if ((res["status"] = "Success")) {
        Swal.fire("Success", "Organization deleted successfully!", "success");
        this.modalRef.close();
        this.spinner.hide();
        this.getOrgs();
      } else {
        Swal.fire({
          type: "error",
          title: "Error",
          text: res.msg
        });

      }
    });
    this.spinner.hide();

  }
  setMonthAndYear(normalizedMonthAndYear:any, datepicker:any) {
    this.date =normalizedMonthAndYear['_d'];
     datepicker.close();
     this.monthDisplay = this.monthNames[this.date.getMonth()]+" "+this.date.getFullYear();
    
     let query ='organizationId='+this.planDetails['organizationId']
     if(this.date){
      var date = new Date(), year = this.date.getFullYear(), month = this.date.getMonth();
      var firstDay = new Date(year, month, 1);
      var lastDay = new Date(year, month + 1, 0);
      let startDate= new Date(firstDay).setHours(0, 0, 0, 0)/1000;
      let endDate = new Date(lastDay).setHours(23, 59, 59, 0)/1000
      query = query+'&startTime='+startDate+"&endTime="+endDate
     }
     this.spinner.show()
    this.organizationService.getProfileInfo(query).subscribe(res => {
      this.spinner.hide();
      if ((res["message"] == "Success")) {
        this.providerList = res.data.auditLogs;
        this.uniqueUser = res.data.uniqueUsersCount;
        
        this.modalRef.result.then(
          result => {
            this.closeResult = `Closed with: ${result}`;
          },
          reason => {
            this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
          }
        );
        this.spinner.hide();
      } else {
        this.spinner.hide();
        Swal.fire({
          type: "error",
          title: "Error",
          text: res.msg
        });
      }
    }, err => {
      this.spinner.hide();
    });
  }
}
